import { render } from "./ReturnOrdersList.vue?vue&type=template&id=e758250e"
import script from "./ReturnOrdersList.vue?vue&type=script&lang=js"
export * from "./ReturnOrdersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__